import { createApp } from 'vue'
import './css/var.less'
import './css/theme.less'
import './css/common.less'
import App from './App.vue'
import i18n from '@/languages/i18n'
import { router } from '@/router'
import { initializeVirtualKeyboardAppearance } from '@/service/keyboard_appearance'
import { initializeSoftwareTheme } from '@/service/software_theme'
import { initializeCustomBackground } from '@/service/custom_background'
import { initializeElectronPerformance } from '@/service/electron_performance'
import { authService } from '@/service/auth/auth_service'
import { setDebug } from '../libs/debug'
setDebug()
void initializeElectronPerformance()
authService.installUserCenterMessageGuard()
authService.preloadUserCenter()
void authService.handleWechatLoginRedirect()
initializeSoftwareTheme()
initializeCustomBackground()
initializeVirtualKeyboardAppearance()
createApp(App).use(i18n).use(router).mount('#app')
